import LoadingSpinner from '$tablet-app/src/app/components/LoadingSpinner';
import { Button } from '@akin-home/buttons/native';
import { TextInput } from '@akin-home/forms/native';
import { Text } from '@akin-home/text/native';
import { useState } from 'react';
import styled from 'styled-components/native';

type Props = {
  loading?: boolean;
  onSubmit(password: string): void;
};

export function EnterNewPasswordForm(props: Props) {
  const { loading, onSubmit } = props;

  const [password, setPassword] = useState('');
  const [confirm_password, setConfirmPassword] = useState('');

  function onPressSubmit() {
    // Todo validate
    onSubmit(password);
  }

  return (
    <Container>
      <Text>Please enter a new password</Text>
      <TextInput
        placeholder="New Password"
        value={password}
        onChangeText={setPassword}
      />

      <TextInput
        placeholder="Confirm new password"
        value={confirm_password}
        onChangeText={setConfirmPassword}
      />

      <Button size="large" onPress={onPressSubmit} disabled={loading}>
        {loading ? <LoadingSpinner color="white" /> : 'Submit'}
      </Button>
    </Container>
  );
}

const Container = styled.View`
  gap: 15px;
  max-width: 500px;
  width: 100%;
  align-self: center;
`;
